import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Phones get the dedicated /mobile single-page layout; iPads (≥768px) and
// desktops stay on the standard SPA. Width-based (not orientation-based) so a
// phone in landscape still goes to /mobile rather than rendering desktop chrome.
const MOBILE_BREAKPOINT_PX = 768;

// Routes that are themselves valid mobile targets — never bounce away.
const MOBILE_OK_PATHS = ['/mobile', '/login'];

const MobileRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSmall, setIsSmall] = useState(
    typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT_PX
  );

  useEffect(() => {
    const check = () => setIsSmall(window.innerWidth < MOBILE_BREAKPOINT_PX);
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
    };
  }, []);

  useEffect(() => {
    if (!isSmall) return;
    if (MOBILE_OK_PATHS.some(p => location.pathname.startsWith(p))) return;
    navigate('/mobile', { replace: true });
  }, [isSmall, location.pathname, navigate]);

  return null;
};

export default MobileRedirect;
